<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" :params="params" />
	<!-- <van-field v-else>
		<template #input> -->
	<van-radio-group v-else v-model="value" :disabled="disabled" direction="horizontal">
		<van-radio v-for="item in params" :key="item.value" :name="item.value">
			{{ item.label }}
		</van-radio>
	</van-radio-group>
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		params: { label: string; value: string; [key: string]: any }[];
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped>
	.show-value {
		display: flex;
		gap: 3px;
		flex-wrap: wrap;
	}
</style>
